<template>
<div class="mlp-tabs">
  <div class="elr-row">
    <div class="elr-col-full">
      <TabNavigation
        @changedTab="changeTab"
        :navItems="tabData.tabs"
      />
    </div>
  </div>
  <div class="mlp-tab-holder">
    <transition-group name="fade">
      <PonyTab
        v-show="tab.show"
        :tab="tab"
        :key="tab.id"
        v-for="tab in tabData.tabs"
      />
    </transition-group>
  </div>
</div>
</template>

<script>
import { tabData } from '../../data/config.json';
import TabNavigation from '../TabNavigation/TabNavigation';
import PonyTab from '../PonyTab/PonyTab';

export default {
  name: 'PonyTabs',
  data() {
    return {
      tabData
    };
  },
  methods: {
    changeTab(payload) {
      this.tabData.tabs
        .filter(o => o.show === true)
        .forEach(o => {
          o.show = false;
        });

      this.tabData.tabs.find(o => o.id === payload.tab).show = true;
    }
  },
  components: {
    TabNavigation,
    PonyTab
  }
};
</script>

<style lang="scss" scoped>

@import '../../assets/sass/config';

.mlp-tab-holder {
  max-width: 1000px;
  width: 100%;
  margin: auto;
  position: relative;
  overflow: hidden;
  height: 375px;

  @media (max-width: 1000px) {
    height: auto;
  }
}
</style>

